import {
  GET_ALL_FEATURES_ERROR,
  GET_ALL_FEATURES_START,
  GET_ALL_FEATURES_SUCCESS,
} from 'constants/action-types/settings/getAllFeatures';
import apiAction from 'helpers/apiAction';

export default queries => dispatch =>
  dispatch(
    apiAction({
      url: '/settings',
      method: 'GET',
      queries,
      API_REQUEST_START: GET_ALL_FEATURES_START,
      API_REQUEST_SUCCESS: GET_ALL_FEATURES_SUCCESS,
      API_REQUEST_FAILURE: GET_ALL_FEATURES_ERROR,
      onSuccess: payload => {
        dispatch({
          type: GET_ALL_FEATURES_SUCCESS,
          payload,
        });
      },
      onEnd: () => false,
    }),
  );
